module.exports = __webpack_public_path__ + "img/paypal.b6b6f508.svg";